import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import MeetingEngagementCard from './MeetingEngagementCard'
import MostUsedEmojisCard from './MostUsedEmojisCard'
import TopRetroTemplatesCard from './TopRetroTemplatesCard'





const TeamDashInsights = (props) => {
  const {teamInsightsRef} = props
  const insights = useFragment(
    graphql`
      fragment TeamDashInsights_insights on TeamInsights {
        id
        ...MostUsedEmojisCard_insights
        ...MeetingEngagementCard_insights
        ...TopRetroTemplatesCard_insights
      }
    `,
    teamInsightsRef
  )

  return (
    React.createElement('div', null
      , React.createElement('h3', { className: "mb-0 pl-2 text-base font-semibold"   ,}, "Team Insights" )
      , React.createElement('div', { className: "flex w-full flex-wrap"  ,}
        , React.createElement(MostUsedEmojisCard, { teamInsightsRef: insights,} )
        , React.createElement(MeetingEngagementCard, { teamInsightsRef: insights,} )
        , React.createElement(TopRetroTemplatesCard, { teamInsightsRef: insights,} )
      )
    )
  )
}
export default TeamDashInsights
